<!--  -->
<template>
  <div class="ai-t-video-content">
    <!-- :playsinline="true" -->
    <video-player
      class="video-player-box"
      ref="videoPlayer"
      :options="playerOptions"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @statechanged="playerStateChanged($event)"
      @ready="playerReadied"
    >
      >
    </video-player>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      name: 'ai-t-video',
      playerOptions: {
        muted: false,
        language: 'zh-CN',
        autoplay: false,
        loop: false,
        // preload: 'auto',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: 'video/mp4',
            src: '',
          },
        ],
        poster: '',
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          fullscreenToggle: true, //全屏按钮
        },
        //  aspectRatio: '16:9',
      },
    }
  },
  //监听属性 类似于data概念
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
  },
  //监控data中的数据变化
  watch: {
    url: {
      handler(val) {
        let url_match = /(http|https):\/\//
        if (url_match.test(val)) {
          this.playerOptions.sources[0].src = val
        } else {
          let origin = window.location.origin
          this.playerOptions.sources[0].src = origin + val
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    // listen event
    onPlayerPlay(player) {},
    onPlayerPause(player) {},
    onPlayerEnded(player) {},
    onPlayerPlaying(player) {},
    onPlayerWaiting(player) {},
    onPlayerLoadeddata(player) {},
    onPlayerTimeupdate(player) {},
    // or listen state event
    playerStateChanged(playerCurrentState) {},
    playerReadied(player) {
      // console.log('the player is readied', player)
    },
    onPlayerCanplay(player) {},
    onPlayerCanplaythrough(player) {
      // console.log('the player is readied', player)
    },
  },
  beforeUpdate() {},
  beforeDestroy() {},
  destroyed() {
    // this.player = null
  },
  activated() {},
}
</script>
<style lang="scss" scoped>
.ai-t-video-content {
  /deep/.video-player {
    display: block;
    // height: 350px;
    // max-height: 350px;
    // margin: 10px auto;

    .video-js {
      width: 99%;
      height: 100%;
      overflow: hidden;
      .vjs-tech {
        // margin-left:-1%;
        width: 101%;
        height: 100%;
        // max-height: 350px;
      }
      .vjs-big-play-button {
        position: absolute;
        display: block;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.7);
        border: none;
        .vjs-icon-placeholder:before {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
    .vjs-controls-disabled .vjs-big-play-button,
    .vjs-has-started .vjs-big-play-button,
    .vjs-using-native-controls .vjs-big-play-button,
    .vjs-error .vjs-big-play-button {
      display: none;
    }
    .vjs-paused .vjs-big-play-button {
      display: block;
    }
  }
}
</style>
